import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface OemIndustryFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const OemFilter = ({
  value = [],
  onChange,
  t,
}: OemIndustryFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_general_oem_name")}
      type="oemName"
      value={value}
      onChange={onChange}
    />
  );
};
